<div class="modal-content">
  <div class="modal-header">
    <h3>{{ title ?? filename }}</h3>
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
  </div>

  <pdf-viewer
    *ngIf="blobPdf"
    [src]="pdfSrc"
    [render-text]="true"
    [original-size]="false"
    [zoom-scale]="'page-width'"
    [render-text-mode]="2"
    [zoom]="0.95"
    [external-link-target]="'_blank'"
    [show-borders]="false"
    [show-all]="true"
    class="browser-pdf"
  ></pdf-viewer>

  <!--Footer-->
  <div class="modal-footer justify-content-center">
    <jhi-bary-button (clickEvent)="handleClick({ cancel: true })" *ngIf="buttons.second" [label]="buttons.second" [outline]="true" class="mr-2"></jhi-bary-button>
    <jhi-bary-button
      *ngIf="buttons.submit"
      [block]="!buttons.second"
      color="primary"
      [label]="buttons.submit"
      (clickEvent)="handleClick({ submit: true })"
      data-id-cypress="modal-confirm"
    ></jhi-bary-button>
  </div>
</div>
